import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getActionTaken,
  getAllCausalities,
  getStudyAeDetails,
  getAllOutComes,
  getSAdvEvents,
  getStudyTitles,
  getActionTakenForAE,
} from "../../../Redux/actions/actions";
import NavigationBar from "../../ReusableComp/NavigationBar";
import { PIFlowLeftNavBar } from "../../ReusableComp/NavBarLeft";
import { Accordion, Col, Row } from "react-bootstrap";
import ToggleButton from "react-toggle-button";
import {
  EVENT_CLASSIFICATION_AESI,
  EVENT_CLASSIFICATION_GRADE_CTCAE,
  EVENT_CLASSIFICATION_LEVEL_BRIGHTON,
  EVENT_CLASSIFICATION_OTHER,
  TOGGLE_NO,
  TOGGLE_YES,
  base_url,
} from "../../../utilities";
import BrightonCase from "../SubjectFlow/BrightonCase";
import GradeCase from "../SubjectFlow/GradeCase";
import moment from "moment";
import axios from "../../../axios-interceptor";
import { useNavigate } from "react-router-dom";
import PopUpModal, { PopUpAlert } from "../../ReusableComp/PopUpModal";
import Loader from "../../ReusableComp/Loader"; // Import the Loader component
import { toast } from "react-toastify";
import Select from "react-select";

const AddNewAeToSubject = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const causalities = useSelector((state) => state.getCausalities);
  const outComes = useSelector((state) => state.getOutComes);
  const actnTakenOpts = useSelector((state) => state.actionTaken);
  const saEvents = useSelector((state) => state.getSAEvents);
  const studyTitles = useSelector((state) => state.getStdyTitls);
  const studyAeDtls = useSelector((state) => state.getStudyAeDtls);
  const actionTakenforAe = useSelector((state) => state.actionTakenforAe);
  const addNewAe = useSelector((state) => state.addNewAe);
  const [selectedAction, setSelectedAction] = useState()
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [toggleSAE, setToggleSAE] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [btnTitle, setBtnTitle] = useState("");
  const [treatmentGiven, setTreatmentGiven] = useState("");
  const [fileNames, setFileNames] = useState([]);
  const [subjData, setSubjData] = useState({});
  const [file, setFile] = useState([]);
  const [regStep, setRegStep] = useState(1);
  const [seriousAE, setSeriousAE] = useState({});
  const [aEClassification, setAEClassification] = useState("");
  const [eventDesc, setEventDesc] = useState();
  const [radioValue, setRadioValue] = useState("");
  const [radioReset, setRadioReset] = useState("");
  const [inputTextNotes, setInputTextNotes] = useState("");
  const [caseDef, setCaseDef] = useState();
  const [caseID, setCaseID] = useState();
  const [firstPgInputs, setFirstPgInputs] = useState({
    date_of_onset: "",
    time_of_onset: "",
    causality_id: "",
    action_taken_for_ae: "",
    outcome_id: "",
    action_taken_id: "",
  });
  const [studyDropdwn, setStudyDropdwn] = useState(true);
  useEffect(() => {
    dispatch(getAllOutComes());
    dispatch(getActionTaken());
    dispatch(getAllCausalities());
    dispatch(getActionTakenForAE());
    dispatch(getSAdvEvents());
  }, [dispatch, btnTitle]);

  ;



  window.onkeydown = keypress;
  function keypress(event) {
    if (event.keyCode == 27) {
      setShowPopup(false);
    }
  }

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleAesiInputText = (e) => {
    let value = e.target.value;
    if (caseDef === EVENT_CLASSIFICATION_AESI) {
      const updatedObject = {
        ...eventDesc,
        event_description_id:
          studyAeDtls[0]?.other_case?.study_aesi_description_id,
        is_case_meets: EVENT_CLASSIFICATION_AESI,
      };
      setEventDesc(updatedObject);
    }

    if (value !== "") {
      setInputTextNotes(value);
    } else {
      setInputTextNotes("");
    }
  };
  const [aeLabel, setAeLabel] = useState("");
  const handleAEClassification = (i) => {
    if (i.target.value !== "Select Adverse Event") {
      const case_def = Number(
        i.target.options[i.target.selectedIndex].getAttribute("case_def")
      );
      const optionValue =
        i.target.options[i.target.selectedIndex].getAttribute("value");
      const optionLabel =
        i.target.options[i.target.selectedIndex].getAttribute("label");
      setAeLabel(optionLabel);
      setEventDesc("");
      setRadioValue("");
      setRadioReset("reset");
      setInputTextNotes("");
      setTreatmentGiven("");
      setTimeOfResolution("");
      setDateOfResolution("");
      setFirstPgInputs((prev) => {
        const blankState = {};
        for (const key in prev) {
          blankState[key] = "";
        }
        return blankState;
      });

      setCaseDef(case_def);
      setCaseID(optionValue);
      setAEClassification(optionValue);

      if (case_def !== EVENT_CLASSIFICATION_OTHER) {
        dispatch(getStudyAeDetails(i));
      }

      if (case_def === EVENT_CLASSIFICATION_OTHER) {
        setEventDesc({
          study_aebank_id: optionValue,
          event_description_id: null,
        });
      }
      if (case_def === EVENT_CLASSIFICATION_AESI) {
        setEventDesc({ study_aebank_id: optionValue });
      }
    } else if (i.target.value === "Select Adverse Criteria") {
      setAEClassification("");
    }
  };
  const handleFileUpload = (event) => {
    const maxIndividualFileSize = 10 * 1024 * 1024; // 10MB in bytes
    const maxCombinedFileSize = 30 * 1024 * 1024; // 30MB in bytes
    const maxFiles = 3; // Maximum allowed files

    const files = Array.from(event.target.files);
    const totalSize = files.reduce((acc, file) => acc + file.size, 0);
    if (files.length > maxFiles) {
      toast.error(`You can upload a maximum of ${maxFiles} files`, {
        toastId: 9,
      });
    } else if (
      files.every((file) => file.size <= maxIndividualFileSize) &&
      totalSize <= maxCombinedFileSize
    ) {
      const newFileNames = files.map((file) => file.name);
      const newFile = files;
      setFile((prevFile) => [...prevFile, ...newFile]);
      setFileNames((prevFileNames) => [...prevFileNames, ...newFileNames]);
    } else {
      if (!files.every((file) => file.size <= maxIndividualFileSize)) {
        toast.error("File size should be less than 10 MB", {
          toastId: 7,
        });
      }
    }
  };

  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedDose, setSelectedDose] = useState(null);
  const [aeSubjData, setAeSubjData] = useState({});
  const [aeSubjectId, setAeSubjectId] = useState();
  const [subjectId, setSubjectId] = useState();
  const [flag, setFlag] = useState(true);
  const [newFlag,SetNewFlag]=useState("");

  const handleSelectedSubj1 = (selectedOption) => {
    setSelectedSubject(selectedOption);

    if (selectedOption.value !== "Select") {
      setSubjectId(selectedOption.value);
      setSelectedDose(" ");
      setAeSubjectId("");

      const selctdSubj = addNewAe?.find(
        (i) => i.subject_id === selectedOption.value
      );
      dispatch(getStudyTitles(selctdSubj?.study_id));
      setSubjData(selctdSubj);
    } else {
      setSubjData({});
      setSubjectId("");
      setToggleSAE(false);
      setSearchTerm("");
      setBtnTitle("");
      setTreatmentGiven("");
      setFileNames([]);
      setSubjData({});
      setFile([]);
      setRegStep(1);
      setSeriousAE({});
      setAEClassification("");
      setEventDesc();
      setRadioValue("");
      setRadioReset("");
      setInputTextNotes("");
      setCaseDef();
      setCaseID("");
      setFirstPgInputs({
        date_of_onset: "",
        time_of_onset: "",
        causality_id: "",
        action_taken_for_ae: "",
        outcome_id: "",
        action_taken_id: "",
      });

    }
  };

  const handleSelectedDose = (selectedOption) => {
    setSelectedDose(selectedOption);

    if (selectedOption.value !== "Select") {
      setAeSubjectId(selectedOption.value);

      const selctdSubD = subjData.previous_doses?.find(
        (i) => i.subject_dose_id === selectedOption.value
      );
      setMinDateofOnset(selctdSubD.date_of_administration)
      setAeSubjData(selctdSubD);
    } else {
      setAeSubjData({});
      setAeSubjectId("");
      setToggleSAE(false);
      setSearchTerm("");
      setBtnTitle("");
      setTreatmentGiven("");
      setFileNames([]);
      setSubjData({});
      setFile([]);
      setRegStep(1);
      setSeriousAE({});
      setAEClassification("");
      setEventDesc();
      setRadioValue("");
      setRadioReset("");
      setInputTextNotes("");
      setCaseDef();
      setCaseID("");
      setFirstPgInputs({
        date_of_onset: "",
        time_of_onset: "",
        causality_id: "",
        action_taken_for_ae: "",
        outcome_id: "",
        action_taken_id: "",
      });

    }
  };

  const options = addNewAe?.map((sub) => ({
    value: sub.subject_id,
    label: `${sub.first_name} ${sub.last_name} - ${sub.subject_code}`,
  }));
  const options1 = subjData.previous_doses?.map((sub) => ({
    value: sub.subject_dose_id,
    label: `${"Dose " + sub.dose}`,
  }));

  const handleDrop = (event) => {
    event.preventDefault(); // Prevent automatic preview
    if (event.dataTransfer.items) {
      const files1 = event.dataTransfer.items;
      const fileList = Array.from(files1).map((item) => item.getAsFile());
      const maxIndividualFileSize = 10 * 1024 * 1024; // 10MB in bytes
      const maxCombinedFileSize = 30 * 1024 * 1024; // 30MB in bytes
      const maxFiles = 3; // Maximum allowed files
      const files = Array.from(fileList);
      const totalSize = files.reduce((acc, file) => acc + file.size, 0);
      if (file.length < 3) {
        if (files.length > maxFiles) {
          toast.error(`You can upload a maximum of ${maxFiles} files`, {
            toastId: 9,
          });
        } else if (
          files.every((file) => file.size <= maxIndividualFileSize) &&
          totalSize <= maxCombinedFileSize
        ) {
          const newFileNames = files.map((file) => file.name);
          const newFile = files;
          setFile((prevFile) => [...prevFile, ...newFile]);
          setFileNames((prevFileNames) => [...prevFileNames, ...newFileNames]);
        } else {
          if (!files.every((file) => file.size <= maxIndividualFileSize)) {
            toast.error("File size should be less than 10 MB", {
              toastId: 7,
            });
          }
        }
      }
      else {
        toast.error(`You can upload a maximum of ${maxFiles} files`, {
          toastId: 9,
        });
      }
    }
  };

  const handleRemoveFile = (index) => {
    setFileNames((prevFileNames) => {
      const newFileNames = [...prevFileNames];
      newFileNames.splice(index, 1);
      return newFileNames;
    });
    setFile((prevFileNames) => {
      const newFileNames = [...prevFileNames];
      newFileNames.splice(index, 1);
      return newFileNames;
    });
  };
  function handleSearch(e) {
    setSearchTerm(e.target.value);
  }
  function handleOption(e) {
    setSearchTerm(e.serious_adverse_event_name);
    setBtnTitle(e.serious_adverse_event_name);
    setSeriousAE({
      label: e.serious_adverse_event_name,
      value: e.serious_adverse_event_id,
    });
    setTimeout(() => {
      setShowPopup(false);
    }, 200);
  }
  function handleDropDown() {
    setShowPopup(!showPopup);
    setSearchTerm("");
  }

  const [showPopup, setShowPopup] = useState(false);

  const registrationSteps = [
    {
      stepTitle: "1. Subject and Dose Selection",
      description: "Selection of subject & dose",
    },
    {
      stepTitle: "2. Adverse Events",
      description: "Adverse Events",
    },

    {
      stepTitle: "3. Preview and Confirm",
      description: "Summary of Adverse event",
    },
  ];

  const handleNavigateNext = () => {
    handleStepChange(1);
  };
  const handleStepChange = (val) => {
    if (val > 0 && regStep < registrationSteps.length + 1) {
      let shift = regStep + val;
      setRegStep(shift);
    }
    if (val < 0 && regStep > 1) {
      let shift = regStep + val;
      setRegStep(shift);
    }
  };
  const [selectedOption, setSelectedOption] = useState('Select');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [dateOfResolution, setDateOfResolution] = useState(null);
  const [timeOfResolution, setTimeOfResolution] = useState(null);
  const [valuForDisble, setValuForDisble] = useState();
  const [actionAdverse, setActionAdverse] = useState("Select");

  const handleTreatment = (e) => {
    let value = e.target.value;
    if (value !== "") {
      setTreatmentGiven(value);
    } else {
      setTreatmentGiven("");
    }
  };
  const handleDateOfResolutionChange = (e) => {
    setDateOfResolution(e.target.value);
  };
  const handleTimeOfResolutionChange = (e) => {
    setTimeOfResolution(e.target.value);
  };

  const handleAeOptions = (e) => {
    const { name, value } = e.target;
    const selectedValue = e.target.value;
      let flagValue = true;
      if (name === "action_taken_for_ae") {
        setSelectedAction(e.target.options[e.target.selectedIndex].innerHTML)
        if (selectedValue === "Select") {
          flagValue = true;
          SetNewFlag("None");
        } else {
          for (var i = 0; i < actionTakenforAe.length; i++) {
            var currentObject = actionTakenforAe[i];
            if (currentObject.action_taken_for_adverse_event_id === value) {
              setActionAdverse(currentObject.action_taken_for_adverse_event_name);
              if (currentObject.action_taken_for_adverse_event_name === "None") {
                flagValue = true;
                SetNewFlag(currentObject.action_taken_for_adverse_event_name)
                setStartDate("")
                setEndDate("")
              } else {
                SetNewFlag(currentObject.action_taken_for_adverse_event_name)
                flagValue = false;
                setStartDate("")
                setEndDate("")
              }
            }
          }
        }
      } 
      setSelectedOption(selectedValue);
      if (name === 'date_of_onset' || name === 'time_of_onset') {
        setDateOfResolution('')
        setTimeOfResolution('')
     }

    if (
      name === "causality_id" ||
      name === "outcome_id" ||
      name === "action_taken_id" ||
      name === "action_taken_for_ae"
    ) {
      if(flag===false){
        flagValue=false;
      }
      if (value !== "Select") {
        setFirstPgInputs((prev) => ({
          ...prev,
          [name]: value,
        }));
      } else {
        setFirstPgInputs((prev) => ({
          ...prev,
          [name]: "",
        }));
      } }else {
        if(flag===false){
          flagValue=false
        } 
      setFirstPgInputs((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    // Set the flag value
    setFlag(flagValue);

    if(name==="date_of_onset"){
      setDateOfResolution('')
      setTimeOfResolution('')
      setStartDate('')
      setEndDate('')
    }
  };
function getEventDescId(val) {
    if (val) {
      setEventDesc(val);
      setValuForDisble(val);
    }
  }
  function handleRadioBtn(val) {
    setRadioValue(val);
  }
  const handleReset = () => {
    setRadioReset("");
  };
  const handleReviewActions = () => {
    setOpen(false);
    navigate("/pisubjectslist");
    setTimeout(() => {
      window.location.reload();
    }, 200);
  };

  const handleSaeToggle = () => {
    setToggleSAE(!toggleSAE);
    setSeriousAE("");
    setSearchTerm("");
    setBtnTitle("Select Adverse Criteria");
  };
  const JustBtwn = "d-flex justify-content-between";
  const next = "orange_btn px-4 orange_btn_mbl";
  const [isbtnDisabled, setIsbtnDisabled] = useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);

  const handelCreateAe = () => {
    let objForSubject = {
      study_id: subjData?.study_id,
      pi_id: localStorage.pi_id,
      subject_dose_id: aeSubjData?.subject_dose_id,
      subject_id: subjData?.subject_id,
      study_aebank_id: eventDesc?.study_aebank_id || null,
      study_case_definition: caseDef === "" ? null : caseDef,
      is_case_meets: eventDesc?.is_case_meets || null,
      event_description_id: eventDesc?.event_description_id || null,
      date_of_onset: firstPgInputs.date_of_onset === "" ? null : firstPgInputs.date_of_onset,
      time_of_onset:firstPgInputs.time_of_onset === "" ? null : firstPgInputs.time_of_onset,
      date_of_resolution: dateOfResolution === "" ? null : dateOfResolution,
      time_of_resolution: timeOfResolution === "" ? null : timeOfResolution,
      causality_id: firstPgInputs.causality_id || null,
      action_taken_for_adverse_event_id:
        firstPgInputs.action_taken_for_ae || null,
      start_date_of_treatment: startDate === "" ? null : startDate,
      end_date_of_treatment: endDate === "" ? null : endDate,
      outcome_id: firstPgInputs.outcome_id || null,
      action_taken_id: firstPgInputs.action_taken_id || null,
      any_treatment_given: treatmentGiven === "" ? null : treatmentGiven,
      is_serious_adverse_event: toggleSAE ? TOGGLE_YES : TOGGLE_NO || null,
      serious_adverse_event_id: seriousAE?.value || null,
      created_by: localStorage.login_user_name,
      // "date_of_onset_sae": dateofOnsetSAE === '' ? null : dateofOnsetSAE,
      input_notes_aesi_others:
        inputTextNotes === "" ? null : inputTextNotes || null,
    };

    // Create a new FormData instance
    const formData = new FormData();

    // Append each property to the FormData
    for (const key in objForSubject) {
      if (objForSubject[key] !== null) formData.append(key, objForSubject[key]);
    }
    for (let i = 0; i < file.length; i++) {
      formData.append("files", file[i]);
    }
    setIsbtnDisabled(true);
    setLoading(true);
    axios
      .post(base_url + "subjects/add_new_adverse_event", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if(res.data.message ==="Event already exists"){

          setOpenAlert(true)
          setLoading(false)

        }else
       { setLoading(false);
        setIsbtnDisabled(false);
        setOpen(true);}
      })
      .catch((error) => {
        setLoading(false);
        setIsbtnDisabled(false);
      });
  };
  const alertClose=()=>{
    setIsbtnDisabled(false)  
    setOpenAlert(false);
  }
  const handleClosePopup = () => {
    setOpen(false);
    setTimeout(() => {
      window.location.reload();
      navigate('/pisubjectslist')

    }, 100);
  };
  const firstPgDisable = Object.keys(firstPgInputs)
    .map((key) => firstPgInputs[key])
    .every((value) => value !== "");


  function handleClose() {
    navigate("/pisubjectslist");
  }

  const [minDateofOnset, setMinDateofOnset] = useState();
  const [today, setToday] = useState("");
  useEffect(() => {
    const currentDate = new Date();
    const formattedDate = currentDate.toDateString();
    setToday(formattedDate);
  }, [today]);

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    setEndDate('')
  };

  const handleEndDateChange = (e) => {
    const selectedEndDate = e.target.value;
    if (selectedEndDate < startDate) {
      return;
    }
    setEndDate(selectedEndDate);
  };
  const [timeError, setTimeError] = useState("");
  const [showTimeError, setShowTimeError] = useState(false)

  function validateTimeOfResolution(event) {
    const inputTime = event.target.value;
    const timeOfOnset = firstPgInputs.time_of_onset;
  
    if (timeOfOnset) {
      // Convert input times to minutes for comparison
      const inputTimeMinutes = timeStringToMinutes(inputTime);
      const timeOfOnsetMinutes = timeStringToMinutes(timeOfOnset);
  
      if (inputTimeMinutes < timeOfOnsetMinutes) {
        const val = "Select time after "+firstPgInputs.time_of_onset
        setTimeError(val)
        setShowTimeError(true)
        // If the input time is before the time of onset, clear the input
        event.target.value = '';
      }
      else{
        setTimeError("val")
        setShowTimeError(false)
      }
    }
  }
  
  
  function timeStringToMinutes(timeString) {
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
  }

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave? Your data may be lost.";
      event.returnValue = message; // Standard for most browsers
      return message; // For some older browsers
    };

    const startListener = () => {
      window.addEventListener('beforeunload', handleBeforeUnload);
    };

    const stopListener = () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };

    // Start listener when component mounts
    startListener();

    // Stop listener when component unmounts
    return () => {
      stopListener();
    };
  }, []);

  return (
    <>
      <div>
        <NavigationBar
          studyDropdwn={false}
          title={"Add Adverse Event To Subject"}
        />
        {/* <PIFlowLeftNavBar /> */}
        <div className="main_body registration_steps_main">
          <div className="row">
            <div
              className="col-lg-3 "
              style={{
                backgroundColor: "#E2E8F0",
              }}
            >
              <div className="lableSteps regstep_title">
                <span>Registration Steps</span>
              </div>

              <div style={{ maxHeight: "66vh", overflowY: "auto" }} className='addaetosub_regstpsmbl'>
                {registrationSteps.map((step, index) => {
                  return (
                    <div
                      key={index}
                      className={`${regStep === index + 1 ? "selectedTabStyl" : ""
                        }`}
                    >
                      <div
                        className={`my-div ${regStep === index + 1
                          ? "registration_steps_selected selectdMr"
                          : "registration_steps"
                          }`}
                        key={index}
                      >
                        <span>{step.stepTitle}</span>
                        <span className="registration_description">
                          {step.description}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>

            </div>
            <div className="col anaeeventmbl">
              <div className="lableContent top-stepper-main addaetosub_regstpsmbl">
                <div className="regStepsMain">
                  {registrationSteps.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <div
                          className={`${regStep >= index + 1 ? "stageSelected" : "stage"
                            }`}
                        >
                          <span>{index + 1}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {regStep === 1 && (
                <div className="subject_reg_body addnewaembl">
                  <div>
                    <Select
                      styles={{ width: "70%" }}
                      options={options}
                      // className="custom-select"
                      value={selectedSubject}
                      className="custom_select_main"
                      onChange={handleSelectedSubj1}
                      placeholder="Select subject"
                    />
                  </div>

                  <div>
                    {subjData?.previous_doses && (
                      <Select
                        styles={{ width: "70%" }}
                        options={options1}
                        value={selectedDose}
                        onChange={handleSelectedDose}
                        className="custom_select_main"
                        placeholder="Select Dose"
                      />
                    )}
                  </div>
                </div>
              )}

              {regStep === 2 ? (
                <div className="subject_reg_body col">
                  <div className="d-flex align-items-center">
                    <label htmlFor="lastName">
                      Is this a serious adverse criteria?
                    </label>
                    <span style={{ marginLeft: "20px" }}>
                      <ToggleButton
                        value={toggleSAE}
                        onToggle={handleSaeToggle}
                        inactiveLabel={"No"}
                        activeLabel={"Yes"}
                        colors={{
                          activeThumb: {
                            base: "rgb(250,250,250)",
                          },
                          active: {
                            base: "rgb(209, 65, 65)",
                          },
                          inactive: {
                            base: "rgb((0, 128, 0)",
                          },
                        }}
                      />
                    </span>
                  </div>
                  {toggleSAE ? (
                    <div className="text-start d-flex flex-column justify-content-between">
                      {/* <Row className={JustBtwn}>
                        <Col className="">
                          <label htmlFor="dateOfseriousAe">
                            Date of onset for serious adverse event<span className="text-danger">*</span>
                          </label>
                        </Col>

                        <Col className="subrej-custom-select-styl ">
                          <input
                          
                            value={dateofOnsetSAE}
                            max={new Date().toISOString().slice(0, 10)}
                            className="customInput py-4"
                            id="dateOfseriousAe"
                            type="date"
                            placeholder="Enter Here"
                            aria-placeholder="#D4D4D4"
                            style={{ padding: "16px 12px", width: "350px",cursor: "not-allowed" }}
                            onChange={handleDateOfOnsetSae}
                            onKeyDown={(e) => e.preventDefault()}
                          />
                        </Col>
                      </Row> */}

                      <Row className='mt-0'>
                        <div className="d-block d-md-flex justify-content-between my-0 my-md-3 my-xxl-3 searchNselectmbl">
                          <Col>
                            <label htmlFor="search_block">
                              Serious Adverse Criteria
                              <span className="text-danger">*</span>
                            </label>
                          </Col>
                          <Col>
                            <div className="search_block" id="search_block">
                              <div
                                className="orange_btn cutm_btn_pdng"
                                onClick={handleDropDown}
                                style={{ width: "350px", padding: "12px 14px" }}
                              >
                                {" "}
                                {btnTitle.length > 30
                                  ? btnTitle.slice(0, 30) + "..."
                                  : btnTitle || "Select Adverse Criteria"}
                                <img
                                  src="./images/icons/selectarrow.svg"
                                  alt=""
                                />
                              </div>
                              {showPopup && (
                                <div
                                  className="search_main"
                                  onBlur={() => {
                                    setTimeout(() => {
                                      if (showPopup) {
                                        setShowPopup(false);
                                      }
                                    }, 200);
                                  }}
                                >
                                  <div className="drop_down_for_search">
                                    <input
                                      type="text"
                                      autoFocus
                                      value={searchTerm}
                                      onChange={handleSearch}
                                      placeholder="Search..."
                                    />
                                    <img
                                      className="sasd"
                                      src="./images/icons/search.svg"
                                      alt=""
                                    />
                                    <div className="eventlist_items">
                                      {saEvents &&
                                        saEvents
                                          .filter((i) => {
                                            const event =
                                              i.serious_adverse_event_name ||
                                              "";
                                            return event
                                              .toLowerCase()
                                              .includes(
                                                (searchTerm || "").toLowerCase()
                                              );
                                          })
                                          .map((i, index) => {
                                            return (
                                              <ul
                                                className="aelistdropdown"
                                                key={index}
                                              >
                                                <li
                                                  className={`${i.serious_adverse_event_name ===
                                                    btnTitle
                                                    ? "selectedOption"
                                                    : ""
                                                    }`}
                                                  onClick={() =>
                                                    handleOption(i)
                                                  }
                                                >
                                                  {i.serious_adverse_event_name ||
                                                    "Select Adverse Criteria"}
                                                </li>
                                              </ul>
                                            );
                                          })}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </Col>
                        </div>
                      </Row>
                    </div>
                  ) : null}
                  <Row className="text-start mt-0">
                    <Col className="align-self-center ">
                      <label htmlFor="aeCalssification">
                        Adverse Event Classification
                        <span className="text-danger">*</span>
                      </label>
                    </Col>

                    <Col className="subrej-custom-select-styl">
                      <select
                        id="aeCalssification"
                        className="orange_select"
                        value={aEClassification}
                        onChange={handleAEClassification}
                      >
                        <option>Select Adverse Event</option>
                        {studyTitles &&
                          studyTitles?.map((i) => {
                            return (
                              <option
                                key={i.study_aebank_id}
                                label={i.study_aebank_event_title}
                                value={i.study_aebank_id}
                                case_def={i.study_case_definition}
                              >
                                {i.study_aebank_event_title}
                              </option>
                            );
                          })}
                      </select>
                    </Col>
                  </Row>
                  {aEClassification !== "" ? (
                    <div className="advEventGroup">
                      <div className={`${caseDef !== EVENT_CLASSIFICATION_OTHER ? 'p-2 p-md-4 p-xxl-4' : ""} bg-light rounded eventClassificationDiv`}>
                        {caseDef === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? (
                          <div className="accordianClass">
                            <BrightonCase
                              handleReset={handleReset}
                              radioValue={radioValue}
                              handleRadioBtn={handleRadioBtn}
                              radioReset={radioReset}
                              getEventDescId={getEventDescId}
                            />
                          </div>
                        ) : caseDef === EVENT_CLASSIFICATION_GRADE_CTCAE ? (
                          <Accordion>
                            <GradeCase
                              handleReset={handleReset}
                              radioValue={radioValue}
                              handleRadioBtn={handleRadioBtn}
                              radioReset={radioReset}
                              getEventDescId={getEventDescId}
                            />
                          </Accordion>
                        ) : caseDef === EVENT_CLASSIFICATION_AESI ? (
                          <Accordion>
                            <div
                              className="fs-6"
                              dangerouslySetInnerHTML={{
                                __html:
                                  studyAeDtls &&
                                  studyAeDtls[0]?.other_case?.study_aesi_description.replace(
                                    /(?:\r\n|\r|\n)/g,
                                    "<br>"
                                  ),
                              }}
                            ></div>
                          </Accordion>
                        ) : (
                          ""
                        )}
                      </div>

                      {caseDef === EVENT_CLASSIFICATION_AESI && (
                        <div className={JustBtwn}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              alignItems: "start",
                            }}
                          >
                            <label htmlFor="input_notes">
                              Event Description
                              <span className="text-danger">*</span>
                            </label>
                            <textarea
                              id="input_notes"
                              style={{
                                width: "100%",
                                minHeight: "100px",
                                padding: "10px",
                                borderColor: "#E1E5E7",
                                borderRadius: "8px",
                              }}
                              value={inputTextNotes}
                              name={"other_input_notes"}
                              placeholder="type here"
                              onChange={handleAesiInputText}
                            />
                          </div>
                        </div>
                      )}

                      {caseDef === EVENT_CLASSIFICATION_OTHER && (
                        <div className={JustBtwn}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              alignItems: "start",
                            }}
                          >
                            <label htmlFor="input_notes">
                              Event Description
                              <span className="text-danger">*</span>
                            </label>
                            <textarea
                              id="input_notes"
                              style={{
                                width: "100%",
                                minHeight: "100px",
                                padding: "10px",
                                borderColor: "#E1E5E7",
                                borderRadius: "8px",
                              }}
                              value={inputTextNotes}
                              name={"other_input_notes"}
                              placeholder="type here"
                              onChange={handleAesiInputText}
                            />
                          </div>
                        </div>
                      )}

                      <div className="d-lg-flex justify-content-between mb-2">
                        <div className="mb-3">
                          <label
                            htmlFor="date_of_onset"
                            className="custm_label_fw"
                          >
                            Date of onset<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            value={firstPgInputs.date_of_onset}
                            className="customInput "
                            id="date_of_onset"
                            name="date_of_onset"
                            type="date"
                            min={minDateofOnset}
                            max={moment(today).format("YYYY-MM-DD")}
                            placeholder="Enter Here"
                            aria-placeholder="#D4D4D4"
                            style={{ padding: "16px 12px", width: "340px" }}
                            onChange={handleAeOptions}
                            onKeyDown={(e) => e.preventDefault()}
                          />
                          {firstPgInputs.date_of_onset?null:
                            <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                            }
                        </div>

                        <div className="">
                          <label
                            htmlFor="time_of_onset"
                            className="custm_label_fw "
                          >
                            Time of onset (24 Hrs)
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            value={firstPgInputs.time_of_onset}
                            className=" customInput"
                            name="time_of_onset"
                            id="time_of_onset"
                            type="time"
                            placeholder="Enter Here"
                            aria-placeholder="#D4D4D4"
                            style={{ padding: "16px 12px", width: "340px" }}
                            onChange={handleAeOptions}
                          />
                          {firstPgInputs.time_of_onset?null:
                            <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                            }
                        </div>
                      </div>
                      <div className="d-lg-flex justify-content-between mb-2">
                        <div className="mb-3">
                          <label
                            htmlFor="dateOfResolution"
                            className="custm_label_fw"
                          >
                            Date of resolution
                          </label>
                          <input
                            value={dateOfResolution}
                            className=" customInput"
                            id="dateOfResolution"
                            min={firstPgInputs.date_of_onset}
                            max={moment(today).format("YYYY-MM-DD")}
                            type="date"
                            placeholder="Enter Here"
                            aria-placeholder="#D4D4D4"
                            style={{ padding: "16px 12px", width: "340px" }}
                            onChange={handleDateOfResolutionChange}
                            disabled={
                              firstPgInputs.date_of_onset !== "" &&
                                firstPgInputs.time_of_onset !== ""
                                ? false
                                : true
                            }
                            onKeyDown={(e) => e.preventDefault()}
                          />
                          {dateOfResolution?null:
                            <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                            }
                        </div>
                          {
                            firstPgInputs.date_of_onset === dateOfResolution ?
                          <div className="">
                          <label htmlFor="lastName" className="custm_label_fw">
                            Time of resolution (24 Hrs) {dateOfResolution && <span style={{ color: "red" }}>*</span> }
                          </label>
                          <input
                              value={timeOfResolution}
                              className="customInput"
                              id="lastName"
                              type="time"
                              placeholder="Enter Here"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                              onChange={handleTimeOfResolutionChange}
                              min={firstPgInputs.time_of_onset}
                              onInput={validateTimeOfResolution}
                            />
                            {timeOfResolution?null:
                            <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                            }
                            <span style={{color:"red", fontSize:"14px"}}>
                              {showTimeError? timeError : null}
                            </span>
                            
                        </div>
                        :
                        <div className="">
                          <label htmlFor="lastName" className="custm_label_fw">
                            Time of resolution (24 Hrs) {dateOfResolution && <span style={{ color: "red" }}>*</span> }
                          </label>
                          <input
                            value={timeOfResolution}
                            className=" custminputbml"
                            id="lastName"
                            type="time"
                            placeholder="Enter Here"
                            aria-placeholder="#D4D4D4"
                            style={{ padding: "16px 12px", width: "340px" }}
                            onChange={handleTimeOfResolutionChange}
                          />
                          {timeOfResolution?null:
                            <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                            }
                        </div>
                          }
                        
                      </div>

                      <div className="coaadrpdnsdsk">
                        <div className="">
                          <label htmlFor="causality">
                            Causality<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                            <select
                              id="causality"
                              value={firstPgInputs.causality_id}
                              name="causality_id"
                              className="selectTag"
                              style={{ width: "345px" }}
                              onChange={handleAeOptions}
                            >
                              <option value={"Select"}>Select</option>
                              {causalities &&
                                causalities.map((i) => {
                                  return (
                                    <option
                                      key={i.causality_id}
                                      value={i.causality_id}
                                    >
                                      {i.causality_name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="">
                          <label htmlFor="outCome">
                            Outcome <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                            <select
                              id="outCome"
                              className="selectTag"
                              name="outcome_id"
                              value={firstPgInputs.outcome_id}
                              style={{ width: "345px" }}
                              onChange={handleAeOptions}
                            >
                              <option value={"Select"}>Select</option>
                              {outComes &&
                                outComes.map((i) => {
                                  return (
                                    <option
                                      value={i.outcome_id}
                                      key={i.outcome_id}
                                    >
                                      {i.outcome_name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="coaadrpdnsdsk">
                        <div className="">
                          <label htmlFor="action_taken_for_ae">
                            Action Taken For Adverse Event{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                            <select
                              id="action_taken_for_ae"
                              className="selectTag"
                              name="action_taken_for_ae"
                              value={firstPgInputs.action_taken_for_ae}
                              // value={selectedOption}
                              style={{ width: "345px" }}
                              onChange={handleAeOptions}
                            >
                              <option value={"Select"}>Select</option>
                              {actionTakenforAe &&
                                actionTakenforAe.map((i) => {
                                  return (
                                    <option
                                      value={
                                        i.action_taken_for_adverse_event_id
                                      }
                                      key={i.action_taken_for_adverse_event_id}
                                    >
                                      {i.action_taken_for_adverse_event_name}
                                    </option>
                                  );
                                })}
                            </select>
                             </div>
                            
                          {(newFlag!=="None" && !flag) && (
                            <div className="start-end-date">
                              <label htmlFor="startDate" className="custm_label_fw">
                                Treatment Start Date {dateOfResolution&&<span className="text-danger">*</span>}
                              </label>
                              <input
                                value={startDate}
                                className="custminputbml"
                                id="startDate"
                                type="date"
                                placeholder="Enter Start Date"
                                aria-placeholder="#D4D4D4"
                                style={{ padding: "16px 12px", width: "340px" }}
                                onChange={handleStartDateChange}
                                min={firstPgInputs?.date_of_onset}
                              />
                            </div>
                           )}
                           </div>
                        
                        <div className="">
                          <label htmlFor="actionTaken">
                            Action Taken For Study Vaccine
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                            <select
                              id="actionTaken"
                              name="action_taken_id"
                              value={firstPgInputs.action_taken_id}
                              className="selectTag"
                              style={{ width: "345px" }}
                              onChange={handleAeOptions}
                            >
                              <option value={"Select"}>Select</option>
                              {actnTakenOpts &&
                                actnTakenOpts.map((i) => {
                                  return (
                                    <option
                                      key={i.action_taken_id}
                                      value={i.action_taken_id}
                                    >
                                      {i.action_taken_name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                          {( newFlag!=="None" && !flag) && (
                            <div className="start-end-date">
                              <label htmlFor="endDate" className="custm_label_fw">
                                Treatment End Date  {dateOfResolution&&<span className="text-danger">*</span>}
                              </label>
                              <input
                                value={endDate}
                                className="custminputbml"
                                id="endDate"
                                type="date"
                                disabled={!startDate}
                                placeholder="Enter End Date"
                                aria-placeholder="#D4D4D4"
                                style={{ padding: "16px 12px", width: "340px" }}
                                onChange={handleEndDateChange}
                                min={startDate}
                              />
                            </div>
                          )}
                        </div>
                     </div>
                     
                      

                      <div className="coaadrpdnsdmbl">
                        <label htmlFor="causality">
                          Causality<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="custom_select_main">
                          <select
                            id="causality"
                            value={firstPgInputs.causality_id}
                            name='causality_id'
                            className="selectTag"
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>Select</option>
                            {causalities &&
                              causalities.map((i) => {
                                return (
                                  <option
                                    key={i.causality_id}
                                    value={i.causality_id}
                                  >
                                    {i.causality_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div className="coaadrpdnsdmbl">
                        <label htmlFor="outCome">
                          Outcome <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="custom_select_main">
                          <select
                            id="outCome"
                            className="selectTag"
                            name='outcome_id'
                            value={firstPgInputs.outcome_id}
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>
                              Select
                            </option>
                            {outComes &&
                              outComes.map((i) => {
                                return (
                                  <option value={i.outcome_id} key={i.outcome_id}>
                                    {i.outcome_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>

                      <div className="coaadrpdnsdmbl">
                        <label htmlFor="action_taken_for_ae">
                          Action Taken For Adverse Event <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="custom_select_main">
                          <select
                            id="action_taken_for_ae"
                            className="selectTag"
                            name='action_taken_for_ae'
                            value={firstPgInputs.action_taken_for_ae}
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>
                              Select
                            </option>
                            {actionTakenforAe &&
                              actionTakenforAe.map((i) => {
                                return (
                                  <option value={i.action_taken_for_adverse_event_id} key={i.action_taken_for_adverse_event_id}>
                                    {i.action_taken_for_adverse_event_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>

                        {( newFlag!=="None" && !flag) && (
                          <div className="start-end-date">
                            <label htmlFor="startDate" className="custm_label_fw start-date">
                              Treatment Start Date {dateOfResolution&&<span className="text-danger">*</span>}
                            </label>
                            <input
                              value={startDate}
                              className="custminputbml selectTag "
                              id="startDate"
                              type="date"
                              placeholder="Enter Start Date"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                              onChange={handleStartDateChange}
                              min={firstPgInputs?.date_of_onset}
                            />
                          </div>
                        )}

                        {/* End Date input */}
                        {( newFlag!=="None" && !flag) && (
                          <div className="start-end-date">
                            <label htmlFor="endDate" className="custm_label_fw end-date">
                              Treatment End Date {dateOfResolution&&<span className="text-danger">*</span>}
                            </label>
                            <input
                              value={endDate}
                              className="custminputbml selectTag"
                              id="endDate"
                              type="date"
                              disabled={!startDate}
                              placeholder="Enter End Date"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                              onChange={handleEndDateChange}
                              min={startDate}
                            />
                          </div>
                        )}
                      </div>

                      <div className="coaadrpdnsdmbl">
                        <label htmlFor="actionTaken">
                          Action Taken For Study Vaccine<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="custom_select_main">
                          <select
                            id="actionTaken"
                            name='action_taken_id'
                            value={firstPgInputs.action_taken_id}
                            className="selectTag"
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>Select</option>
                            {actnTakenOpts &&
                              actnTakenOpts.map((i) => {
                                return (
                                  <option
                                    key={i.action_taken_id}
                                    value={i.action_taken_id}
                                  >
                                    {i.action_taken_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>


                      {/* ////////////////////// */}



                      <div className={JustBtwn}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            alignItems: "start",
                          }}
                        >
                          <label htmlFor="treatment_given">
                            Any treatment given
                          </label>
                          <textarea
                            id="treatment_given"
                            style={{
                              width: "100%",
                              minHeight: "100px",
                              padding: "10px",
                              borderColor: "#E1E5E7",
                              borderRadius: "8px",
                            }}
                            value={treatmentGiven}
                            placeholder="type here"
                            onChange={handleTreatment}
                          />
                        </div>
                      </div>
                      <div>
                        <span
                          style={{ display: "flex", alignContent: "start" }}
                        >
                          <label htmlFor="file-input-label">Attach files</label>
                        </span>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "20px",
                          }}
                        >
                          <div
                            style={{ width: "500px", alignItems: "center" }}
                            id="drop-area"
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                          >
                            {/* <div className="upload-icon" style={{}}>
                              <img
                                style={{
                                  height: "100px",
                                  margin: "6px",
                                  paddingLeft: "5px",
                                }}
                                src="./images/icons/Upload.svg"
                                alt=""
                              />
                              <h5>Drag and drop files here</h5>
                              <h5>or</h5>
                              <input
                                type="file"
                                id="file-input"
                                multiple
                                onChange={handleFileUpload}
                                disabled={fileNames.length >= 3 ? true : false}
                              />
                              <label htmlFor="file-input" className="">
                                <span
                                  className="gray_btn px-4"
                                  style={{
                                    cursor: "pointer",
                                    opacity: fileNames.length >= 3 ? "50%" : "",
                                  }}
                                >
                                  Browse Files
                                </span>
                              </label>
                            </div> */}

                            <div className="upload-icon" style={{}}>
                              <img
                                style={{
                                  height: "100px",
                                  margin: "6px",
                                  paddingLeft: "5px",
                                }}
                                src="./images/icons/Upload.svg"
                                alt=""
                              />
                              <h5 className='subjreg_drp_zone_txt'>Drag and drop files here </h5>
                              <h5 className='subjreg_drp_zone_txt'>or</h5>
                              <input
                                type="file"
                                id="file-input"
                                multiple
                                onChange={handleFileUpload}
                                disabled={fileNames.length >= 3 ? true : false}
                                accept=".pdf, .ppt, .txt, .docx, .doc, .xls, .csv, .jpeg, .jpg, .png"
                              />
                              <label
                                htmlFor="file-input"
                                className=""
                              >
                                <span className="gray_btn px-4" style={{ opacity: fileNames.length >= 3 ? "50%" : '' }}>Browse Files</span>
                              </label>
                              <p  >(PDF, PPT, TXT, DOCX, DOC, XLS, CSV, JPEG, JPG, PNG)</p>
                            </div>
                            <div id="file-list" style={{ margin: "10px" }}>
                              {fileNames.map((fileName, index) => (
                                <div key={fileName} className="file-container">
                                  <div>{fileName}</div>
                                  {/* <button
                                    className="close-icon"
                                    style={{color:"red"}}
                                    onClick={() => handleRemoveFile(index)}
                                  >
                                    X
                                  </button> */}
                                  <span className='close-icon' style={{ color: 'red'}} title='Click on this to delete the file' onClick={() => handleRemoveFile(index)}>✕</span>


                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : (
                ""
              )}
              {regStep === 3 && (
                <div className="subject_reg_body">
                  <div className={JustBtwn}>
                    <div className="card step5_cards viewCardStyl">
                      <div className="card-header cardHeading">
                        <h6>Adverse Events</h6>
                      </div>
                      <div className=" cardBody table-responsive body">
                        <table className="table card_columns_styl border-0 ">
                          <tbody>
                            <tr>
                              <td>Date & Time of onset</td>
                              <td>
                                {moment(firstPgInputs.date_of_onset).format(
                                  "DD-MM-YYYY"
                                )}{" "}
                                {firstPgInputs.time_of_onset}
                              </td>
                            </tr>
                            <tr>
                              <td>Date & Time of Resolution</td>
                              <td>
                                {dateOfResolution !== ""
                                  ? moment(dateOfResolution).format(
                                    "DD-MM-YYYY"
                                  ) +
                                  " " +
                                  timeOfResolution
                                  : "-"}
                              </td>
                            </tr>
                            <tr>
                              <td>Adverse Event</td>
                              <td>{aeLabel === undefined ? "-" : aeLabel}</td>
                            </tr>
                            <tr>
                              <td>Serious Adverse Criteria</td>
                              <td>{seriousAE.label ? seriousAE.label : "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="registrationStepsFooter">
                {regStep > 1 && (
                  <button
                    className="white_btn white_btn_mbl"
                    onClick={() => handleStepChange(-1)}
                  >
                    Previous
                  </button>
                )}

                {regStep === 1 && (
                  <div className=" registrationStepsFooter">
                    <button className="white_btn px-3 exit_white_btn_mbl" onClick={handleClose}>
                      Cancel
                    </button>
                    <button
                      className={next}
                      onClick={() => handleStepChange(1)}
                      disabled={!subjectId || !aeSubjectId || !selectedDose}
                    >
                      Next
                    </button>
                  </div>
                )}
                {regStep === 2 && (

                  <button
                    className={next}
                    onClick={handleNavigateNext}
                    disabled={
  selectedOption==='no' ? false:
toggleSAE && seriousAE!=='' && aEClassification!=='' &&eventDesc!==undefined && inputTextNotes !=='' && firstPgDisable && !dateOfResolution  ?false:
toggleSAE && seriousAE!=='' && aEClassification!=='' &&eventDesc!==undefined && inputTextNotes !=='' && firstPgDisable && dateOfResolution && selectedAction !=='None' &&startDate && endDate  ?false:

 !toggleSAE &&  aEClassification!=='' && eventDesc!==undefined && eventDesc!=='' &&inputTextNotes !=='' && firstPgDisable && ! dateOfResolution ?false:
!toggleSAE &&  aEClassification!=='' && valuForDisble!==undefined && firstPgDisable && ! dateOfResolution ?false:

 !toggleSAE &&  aEClassification!=='' && eventDesc!==undefined && eventDesc!=='' &&inputTextNotes !=='' && firstPgDisable && dateOfResolution && selectedAction !=='None' &&startDate && endDate ?false:
!toggleSAE &&  aEClassification!=='' && valuForDisble!==undefined && firstPgDisable && dateOfResolution && selectedAction !=='None' &&startDate && endDate ?false:

 !toggleSAE &&  aEClassification!=='' && eventDesc!==undefined && eventDesc!=='' &&inputTextNotes !=='' && firstPgDisable && dateOfResolution && selectedAction ==='None' ?false:
!toggleSAE &&  aEClassification!=='' && valuForDisble!==undefined && firstPgDisable && dateOfResolution && selectedAction ==='None' ?false:

toggleSAE&& seriousAE!==''&& valuForDisble !== undefined&& aEClassification!==''&& eventDesc!==undefined && firstPgDisable && !dateOfResolution ?false:
toggleSAE&& seriousAE!==''&& inputTextNotes !==''&& aEClassification!==''&& eventDesc!==undefined && firstPgDisable && !dateOfResolution ?false:

toggleSAE&& seriousAE!==''&& valuForDisble !== undefined&& aEClassification!==''&& eventDesc!==undefined && firstPgDisable && dateOfResolution && selectedAction !=='None' &&startDate && endDate ?false:
toggleSAE&& seriousAE!==''&& valuForDisble !== undefined&& aEClassification!==''&& eventDesc!==undefined && firstPgDisable && dateOfResolution && selectedAction ==='None' &&!startDate && !endDate ?false:

toggleSAE&& seriousAE!==''&& inputTextNotes !==''&& aEClassification!==''&& eventDesc!==undefined && firstPgDisable && dateOfResolution && selectedAction ==='None' && !startDate && !endDate ?false:
toggleSAE&& seriousAE!==''&& inputTextNotes !==''&& aEClassification!==''&& eventDesc!==undefined && firstPgDisable && dateOfResolution && selectedAction !=='None' && startDate && endDate ?false:

 
true 
                  }
                  >
                    Next
                  </button>

                )}

                {regStep === 3 && (
                  <button
                    className="orange_btn orange_btn_mbl"
                    onClick={handelCreateAe}
                    disabled={isbtnDisabled}
                  >
                    Submit
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <PopUpModal
          handleClose={handleClosePopup}
          open={open}
          title={"Success!"}
          msg={"Adverse event created successfully!"}
          close={"Close"}
          actionbtn={"Done"}
          onConfirm={handleReviewActions}
        />
        <PopUpAlert
          handleClose={alertClose}
          open={openAlert}
          // title={"?"}
          msg={<span className="lower">{'This event has already been created on the selected date.'}</span>}
          close={"Close"}
          actionbtn={''}
          // onConfirm={handleReviewActions}
        />
      </div>
      {loading && <Loader />}
    </>
  );
};

export default AddNewAeToSubject;
